module.exports = __webpack_public_path__ + "img/raliyc_musium.d5332499.jpg";